/*
* Project: LegalPlace assistant
* File: src/redux/reducers/load_ovc.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/

import { UPDATE_OVC } from '../actions/load_ovc';
import { generateId1 } from '../../components/utils/misc';
import lpApp from '../../app/lp_app';

function initParentingVars(){
    let vars_parents = {}
    // extract the variable to option thing =
    Object.keys(lpApp.references.options).map(idx => {
        lpApp.references.getOption(idx).variables.map(jdx => {
            vars_parents[jdx] = idx
        });
    });
    return vars_parents;
}


export function initParentingOpts(){
    let opts_parents = {}
    // debugger;
    // extract the variable to option thing =
    Object.keys(lpApp.references.options).map(idx => {
        lpApp.references.getOption(idx).children.map(jdx => {
            opts_parents[jdx] = idx
        });
    });
    return opts_parents;
}

let ops_par = {};
let var_par = {};
export function getFirstMultipleParent(var_idx){
    // get the last variable who is a multiple or false if there is not
    let opt_idx = var_par[var_idx]
    let _result = false;
    // debugger;
    while(opt_idx >= 0){
        if(lpApp.references.getOption(opt_idx).meta.multiple){
            _result = opt_idx;
        }
        if(ops_par[opt_idx]){
            opt_idx = ops_par[opt_idx]
        }else{
            break;
        }
    }
    return _result
}
export function getOFirstMultipleParent(var_idx){
    // get the last variable who is a multiple or false if there is not
    let opt_idx = var_idx;
    let _result = false;
    let r = [];
    while(opt_idx){
        r.push(opt_idx);
        opt_idx = lpApp.indexes.grandpa.getFather(opt_idx);
    }
    r = r.filter(idx => lpApp.references.options[idx].meta.multiple === true);
    if(r.length > 0)
        return r[0];
    else
        return false;
}

export function updateOVCReducer(state={o:{}, v: {}, c:{}}, action){

    if(action.type == UPDATE_OVC){
        let a = JSON.stringify(action.ovc);
        let result = JSON.parse(a);
        // console.log(result);
        let on_opts = {};


        ops_par = initParentingOpts();
        var_par = initParentingVars();



        let options_flat = {}
        let opts = result.o;
        if((typeof opts == 'undefined') || (opts.length))
            opts = {}
        let opts_keys = Object.keys(opts);

        let i = 0;
        if (opts_keys.length === 0) return result;
        for(; i < opts_keys.length; i += 1){
            let idx = opts_keys[i]
            let now_ = opts[idx];
            if((typeof now_ == 'object') && (now_.length > 1)){
                let keys_list = [];
                // Setting multiples
                if(getOFirstMultipleParent(idx) == idx){
                    for(let i = 0; i < now_.length-1; i += 1)
                        keys_list.push(generateId1(4));
                    lpApp.indexes.multiples.addMultiple(idx, keys_list);
                } else {
                    keys_list = lpApp.indexes.multiples.getMultiple(getOFirstMultipleParent(idx));
                }
                for(let j = 0; j < now_.length; j += 1){
                    let jdx = now_[j];
                    if(jdx == ""){
                        // console.log("faragh")
                    }else{
                        if(j == 0){
                            // the first option
                            options_flat[jdx] = true;
                            // options_flat[idx] = true;
                        }else{
                            let k = keys_list[j-1];
                            if(lpApp.indexes.multiples.getMultiple(getOFirstMultipleParent(idx))){
                                let m_ = lpApp.indexes.multiples.getMultiple(getOFirstMultipleParent(idx));
                                if((i-1) > m_.length){
                                    options_flat[idx+'_'+k] = true;
                                    options_flat[jdx+'_'+k] = true;

                                }else{

                                    options_flat[idx+'_'+k] = true;
                                    options_flat[jdx+'_'+k] = true;
                                }
                            }
                            else{
                                // lpApp.indexes.multiples.addMultiple(idx, [k]);
                                options_flat[idx+'_'+k] = true;
                                options_flat[jdx+'_'+k] = true;
                            }

                            // window.lp_mult[idx] = true;
                        }
                    }
                }
            }else{
                if(now_ == "");
                    // console.log("faragh");
                else
                    options_flat[now_] = true;
            }
        }

        // checkbox flat
        let checkbox_flat = {};
        let chk = result.c;
        if((typeof chk == 'undefined') || (chk.length))
        chk = {}
        let chk_keys = Object.keys(chk)
        i = 0;

        for(i = 0; i < chk_keys.length; i += 1){
            let idx = chk_keys[i];
            let now_ = chk[idx].c ? chk[idx].c : chk[idx];
            let now_opts = chk[idx].v;

            if((now_ != null) && now_ && (typeof now_ == 'object') && now_.length > 1){
                for(let j = 0; j < now_.length; j += 1){
                    let jdx = now_[j];
                    if(j == 0){
                        checkbox_flat[idx] = jdx;
                    }else{
                        let mk = getOFirstMultipleParent(idx)
                        if(mk){
                            if(typeof lpApp.indexes.multiples.getMultiple(mk) != 'undefined')
                                checkbox_flat[idx + '_' + lpApp.indexes.multiples.getMultiple(mk)[j-1]] = jdx

                            // debugger;
                        }
                    }
                }
            }else{
                checkbox_flat[idx] = typeof now_ == 'object' ? now_[0] : now_;
            }

            if((typeof now_opts == 'object') && typeof now_opts.length == 'undefined'){
                let c_opts = now_opts;
                now_opts = [];
                for(var i in c_opts){
                    now_opts.push(c_opts[i]);
                }
            }
            if((typeof now_opts == 'object') && (now_opts.length > 1)){
                for(let j = 0; j < now_opts.length; j += 1){

                    let jdx = now_opts[j];
                    // console.log(idx+ ' : '+jdx);
                    if(jdx == ""){
                        // console.log("faragh")
                    }else{
                        if(j == 0){
                            // the first option
                            options_flat[jdx] = true;
                        }else{
                            let k = generateId1(4);

                            if(lpApp.indexes.multiples.getMultiple(idx)){
                                let tmp = lpApp.indexes.multiples.getMultiple(idx);
                                tmp.push(k);
                                lpApp.indexes.multiples.addMultiple(idx, tmp);
                            }
                            else
                                lpApp.indexes.multiples.addMultiple(idx, [k]);
                            options_flat[jdx+'_'+k] = true;
                        }
                    }
                }
            }else{
                if(now_opts == "");
                    // console.log("faragh");
                else
                    options_flat[now_opts] = true;
            }
        }
// console.log("hello")
        // extract informaion from V
        // don't waste variables xD hahahahha
        let vars_flat = {}
        i = 0;
        let v_keys = Object.keys(result.v);
        let v_ = result.v;
        for(i = 0; i < v_keys.length; i += 1){
            let idx = v_keys[i];
            let now_ = v_[idx];
            if(typeof now_ == 'object' && now_.length > 1){
                for(let j = 0; j < now_.length; j += 1){
                    let jdx = now_[j];
                    if(j == 0){
                        vars_flat[idx] = jdx;
                    }else{
                        let mk = getFirstMultipleParent(idx)
                        if(typeof mk != "undefined"){
                            // debugger;
                            if(typeof lpApp.indexes.multiples.getMultiple(mk) != 'undefined')
                                vars_flat[idx + '_' + lpApp.indexes.multiples.getMultiple(mk)[j-1]] = jdx
                        }
                    }
                }
            }else{
                vars_flat[idx] = typeof now_ == 'object' ? now_[0] : now_;
            }
        }
        // console.log(options_flat)
        result.oF = options_flat;
        result.vF = vars_flat;
        result.cF = checkbox_flat;
        // result.o_ = on_opts;
        return result;
    }
    return state;
}




// WEBPACK FOOTER //
// ./src/redux/reducers/load_ovc.js